module.exports = __webpack_public_path__ + "media/src/assets/images/amenities_blue/comb-4caa0cab1c4c032d2ee1704292e8b3bc.svg";